
import { computed, defineComponent, ref, toRefs } from "vue-demi";
import BytedIconPause from '@byte-design/vue-icons/icons/Pause'
import BytedIconPlay from '@byte-design/vue-icons/icons/Play'

const removeProtocol = (url = ''): string => {
  return url.replace(/^https?:/, '');
};

const name = 'VideoPlayer';
export default defineComponent({
  name,
  components: {
    BytedIconPause,
    BytedIconPlay
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    post: {
      type: String,
    },
    vid: {
      type: String,
    },
    invalidText: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { post, src, vid } = toRefs(props);
    const showHint = ref(false);
    const waiting = ref(false);
    const playing = ref(false);
    const firstPlay = ref(true);
    const postUrl = ref('');
    const video = ref(null)
    const poster = computed(() => {
      return removeProtocol(post.value || postUrl.value)
    })
    const videoUrl = computed(() => {
      return src.value.startsWith('http') ? src.value : removeProtocol(atob(src.value))
    })
    const togglePlay = async () => {
      const player = video.value
      if (playing.value) {
        player.pause()
      } else {
        const p = player.play()
        if (p.then) {
          p.then(() => {
            // this.firstPlay = false
          })
        }
        if (p.catch) {
          // play方法可能返回一下promise，catch一下
          p.catch(() => {
            //
          })
        }
      }
    }
    const onWaiting = () => {
      waiting.value = true
    }
    const onPlaying = () => {
      waiting.value = false
      firstPlay.value = false
      playing.value = true
    }
    const onPause = () => {
      waiting.value = false
      playing.value = false
    }
    const videoSelection = () => {
      if (props.invalidText) {
        showHint.value = true
        return
      }
      emit('video-selection', { src, post, vid })
    }
    return {
      video,
      waiting,
      playing,
      showHint,
      videoSelection,
      firstPlay,
      postUrl,
      poster,
      videoUrl,
      onWaiting,
      togglePlay,
      onPlaying,
      onPause,
    }
  },
})
